import { render, staticRenderFns } from "./DashboardListItem.vue?vue&type=template&id=49002832&scoped=true&"
import script from "./DashboardListItem.vue?vue&type=script&lang=js&"
export * from "./DashboardListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49002832",
  null
  
)

export default component.exports